(function(h,o,u,n,d) {
    h=h[d]=h[d]||{q:[],onReady:function(c){h.q.push(c)}}
    d=o.createElement(u);d.async=1;d.src=n
    n=o.getElementsByTagName(u)[0];n.parentNode.insertBefore(d,n)
    })(window,document,'script','https://www.datadoghq-browser-agent.com/us5/v6/datadog-rum.js','DD_RUM')
    window.DD_RUM.onReady(function() {
    window.DD_RUM.init({
        clientToken: 'pub44b3c9d78960668351064836108c3c7b',
        applicationId: '3fdac13a-df68-4914-9044-f4c6f766cb0d',
        // `site` refers to the Datadog site parameter of your organization
        // see https://docs.datadoghq.com/getting_started/site/
        site: 'us5.datadoghq.com',
        service: 'okoa-skin',
        env: 'production',
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 50,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'allow',
    });
    const parsedData = JSON.parse(localStorage.getItem('context_data'));
    if (parsedData) {
        try {
            window.DD_RUM.setUserProperty('id', parsedData.userId)
        } catch (error) {
            console.error('Error parsing context_data from localStorage:', error);
        }
        try {
            window.DD_RUM.setGlobalContextProperty('pixel', parsedData);
        } catch (error) {
            console.error('Error setting global context property:', error);
        }
    }
    });
